import { render, staticRenderFns } from "./DiscussAdd.vue?vue&type=template&id=6bd65d40"
import script from "./DiscussAdd.vue?vue&type=script&lang=js"
export * from "./DiscussAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports